export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';

export const showModal = (text, btntext) => ({
    type: MODAL_SHOW,
    payload: {
        text,
        btntext
    }
})

export const hideModal = () => ({
    type: MODAL_HIDE,
    payload: {
        text: '',
        btntext: ''
    }
})
